import { styled } from "@mui/material/styles";
import { Paper as PaperMaterial } from "@mui/material";
import { memo } from "react";

const Paper = styled(PaperMaterial)(({ theme }) => ({
	backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
	...theme.typography.body2,
	padding: theme.spacing(2),
	textAlign: "left",
	color: theme.palette.text.secondary,
}));

function ItemBase({ children, ...rest }) {
	return <Paper {...rest}>{children}</Paper>;
}

export const Item = memo(ItemBase);